import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PayoutOrderListHeader = _resolveComponent("PayoutOrderListHeader")!
  const _component_PayoutOrderListFilter = _resolveComponent("PayoutOrderListFilter")!
  const _component_PayoutOrderList = _resolveComponent("PayoutOrderList")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PayoutOrderListHeader),
    _createVNode(_component_PayoutOrderListFilter),
    _createVNode(_component_PayoutOrderList)
  ], 64 /* STABLE_FRAGMENT */))
}